import { getVar } from '@/common_util/misc/environment'

export const IS_DEBUG = getVar('fe_debug', 'boolean')
export const NO_REDIRECT = getVar('no_redirect', 'boolean')

export const currentEnvironment = process.env.VUE_APP_DEPLOY_ENV;

export const ACCOUNT_URI_ENVIRONMENT = process.env.VUE_APP_ACCOUNT_URI;

export function getRegion(region: string) {
    return getVar('region') as string || region
}
